export const PAGE_TITLE = 'Job Cards';
export const PAGE_SINGLE_TITLE = 'Job Card';
export const LINK_URL = 'job-cards';
export const inputFields = {
  job_card_number: {
    type: 'string',
    required: true,
    title: 'Job Card Number',
    inputType: 'text',
  },
  customer: {
    type: 'related',
    required: true,
    title: 'Customer',
    inputType: 'select',
  },
  vendor: {
    type: 'related',
    required: true,
    title: 'Vendor',
    inputType: 'select',
  },
  vehicle: {
    type: 'related',
    required: true,
    title: 'Vehicle',
    inputType: 'select',
  },
  service_type: {
    type: 'select',
    required: true,
    title: 'Service Type',
    inputType: 'select',
    options: ['Maintenance', 'Repair', 'Inspection'],
  },
  service_description: {
    type: 'string',
    required: true,
    title: 'Service Description',
    inputType: 'textarea',
    rows: 3,
  },
  service_date: {
    type: 'date',
    required: true,
    title: 'Service Date',
    inputType: 'date',
  },
  service_status: {
    type: 'select',
    required: true,
    title: 'Service Status',
    inputType: 'select',
    options: ['Pending', 'In Progress', 'Completed'],
  },
  service_notes: {
    type: 'string',
    required: false,
    title: 'Service Notes',
    inputType: 'textarea',
    rows: 2,
  },
  service_technician: {
    type: 'related',
    required: true,
    title: 'Service Technician',
    inputType: 'select',
  },
  service_labor_cost: {
    type: 'number',
    required: true,
    title: 'Labor Cost',
    inputType: 'number',
  },
  service_total_cost: {
    type: 'number',
    required: true,
    title: 'Total Cost',
    inputType: 'number',
  },
  service_payment_status: {
    type: 'select',
    required: true,
    title: 'Payment Status',
    inputType: 'select',
    options: ['Paid', 'Unpaid', 'Partial'],
  },
  service_payment_method: {
    type: 'select',
    required: false,
    title: 'Payment Method',
    inputType: 'select',
    options: ['Cash', 'Card', 'Cheque', 'Online'],
  },
  service_payment_date: {
    type: 'date',
    required: false,
    title: 'Payment Date',
    inputType: 'date',
  },
  month_year: {
    type: 'string',
    required: false,
    title: 'Month/Year',
    inputType: 'text',
  },
  form_type: {
    type: 'array',
    required: false,
    title: 'Form Type',
    inputType: 'checkbox',
  },
  odometer_reading: {
    type: 'number',
    required: false,
    title: 'Odometer Reading',
    inputType: 'number',
  },
  next_service_due_odometer_reading: {
    type: 'number',
    required: false,
    title: 'Next Service Due Odometer',
    inputType: 'number',
  },
  wheel_alignment_service: {
    type: 'select',
    required: false,
    title: 'Wheel Alignment Service',
    inputType: 'select',
    options: ['NO WHEEL ALIGNMENT', 'WHEEL ALIGNMENT'],
  },
  brake_pad_status: {
    type: 'select',
    required: false,
    title: 'Brake Pad Status',
    inputType: 'select',
    options: ['1', '2', '3', '4', '5'],
  },
  tyres_changed_or_purchased: {
    type: 'number',
    required: false,
    title: 'Tyres Changed/Purchased',
    inputType: 'number',
  },
  wheel_balancing_done: {
    type: 'number',
    required: false,
    title: 'Wheel Balancing Done',
    inputType: 'number',
  },
  nalki_used: {
    type: 'number',
    required: false,
    title: 'Nalki Used',
    inputType: 'number',
  },
  other_services: {
    type: 'string',
    required: false,
    title: 'Other Services',
    inputType: 'textarea',
    rows: 2,
  },
  check_list: {
    type: 'array',
    required: false,
    title: 'Checklist',
    inputType: 'checkbox',
  },
  terms_and_conditions_accepted: {
    type: 'boolean',
    required: false,
    title: 'Terms & Conditions Accepted',
    inputType: 'checkbox',
  },
};
export const initialValues = {
  customer: '',
  vendor: '',
  job_card_number: '',
  vehicle: '',
  service_type: 'Maintenance',
  service_description: '',
  service_date: '',
  service_status: 'Pending',
  service_notes: '',
  service_technician: '',
  services_used: [],
  products_used: [],
  service_parts_used: [],
  service_labor_cost: '',
  service_total_cost: '',
  service_payment_status: 'Unpaid',
  service_payment_method: '',
  service_payment_date: '',
  service_images: [],
  service_documents: [],
  month_year: '',
  form_type: [],
  odometer_reading: '',
  next_service_due_odometer_reading: 5000,
  wheel_alignment_service: '',
  brake_pad_status: '',
  tyres_changed_or_purchased: 0,
  wheel_balancing_done: 0,
  nalki_used: 0,
  other_services: '',
  check_list: [],
  terms_and_conditions_accepted: false,
};

export const view_all_table = [
  { name: 'Job Card No', value: 'job_card_number' },
  { name: 'Total Cost', value: 'service_total_cost' },
  {
    name: 'Customer',
    value: 'customer',
    related: true,
    field: 'name',
  },
  {
    name: 'Vehicle',
    value: 'vehicle',
    related: true,
    field: 'vehicle_number',
  },
  { name: 'Vendor', value: 'vendor', related: true, field: 'name' },
  { name: 'Service Date', value: 'service_date', date: true },
  { name: 'Created Date', value: 'createdAt', date: true },
];

export const SIDEBAR_OPTIONS = [
  {
    id: 'name',
    field: 'name',
    label: 'Name',
    type: 'string',
    search_type: 'search',
    inputType: 'text',
    condition: '',
  },

  {
    id: 'vehicle',
    field: 'vehicle',
    label: 'Vehicle Number',
    type: 'related',
    search_type: 'exact',
    inputType: 'select',
    condition: '',
  },
];
